import React, { useContext } from 'react'
import { ThemeContext } from 'styled-components'
import styled from 'styled-components'
const Text = props => {
    const theme = useContext(ThemeContext)
    const StyledText = styled.div`
    display : ${props.display || 'flex'} ;
    direction : ${props.lang ? props.lang === 'fa' || props.lang === 'ar' ? 'rtl' : 'ltr' : 'rtl'};
    justify-content : ${props => props.justifyContent || 'flex-start'};
    align-items : ${props.alignItems || 'center'};
    color : ${props.color || theme.text};
    /* background-color : ${props.backgroundColor || 'transparent'}; */
    /* font-weight : ${props.fontWeight || theme.fontWeight}; */
    font-size : ${props.fontSize ? props.fontSize : props.style ? props.style.fontSize : props.className ? props.className.fontSize : theme.fontSize};
    width : ${props.width || 'auto'};
    height : ${props => props.height ? props.style : props.style.height ? props.height : props.className ? props.className.height : 'auto'};
    padding : ${props.lang === 'fa' || props.lang === 'ar' ? '0.2em 0.8em 0.2em 0em' :'0.2em 0em 0.2em 0.8em' };
    border-radius : ${props.borderRadius || 'none'};
    border : ${props.border ? props.border : props.className ? props.className.border : 'none'};
    line-height : 24px;
    /* border-radius : ${props.borderRadius || 0}; */
    /* border : 1px solid; */
    `
    return (
        <StyledText
            {...props}
            ref={props.innerRef}
            style={{ ...props.style }}
            className={props.className}
        >
            {props.children}
        </StyledText>
    )
}


export default Text
